import { getExpression } from 'utilities';
import { GetTotalPublishedValuationsExpressionParams } from './getTotalPublishedValuationsExpression.types';

const getTotalPublishedValuationsExpression = (params: GetTotalPublishedValuationsExpressionParams): string => {
  const { allPublishedValuationsExpression, alphabet, currentColumn } = params;

  // Column legend (-1 excluding Company Column)
  const columnLegend = alphabet[currentColumn - 1];

  // Total Published Valuations Expression
  const totalPublishedDirectInvestedCapitalExpression = getExpression({
    columnLegend,
    expr: `SUM(${allPublishedValuationsExpression})`,
  });

  return totalPublishedDirectInvestedCapitalExpression;
};

export default getTotalPublishedValuationsExpression;
